(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function zonedParts(date, timeZone) {
      var fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      var map = {};
      var parts = fmt.formatToParts(date);
      var i;
      for (i = 0; i < parts.length; i++) map[parts[i].type] = parts[i].value;
      var hour = parseInt(map.hour, 10);
      if (map.dayPeriod) {
        var period = String(map.dayPeriod).toLowerCase();
        if (period.indexOf('pm') !== -1 && hour < 12) hour += 12;
        if (period.indexOf('am') !== -1 && hour === 12) hour = 0;
      }
      if (hour === 24) hour = 0;
      return {
        year: parseInt(map.year, 10),
        month: parseInt(map.month, 10),
        day: parseInt(map.day, 10),
        hour: hour,
        minute: parseInt(map.minute, 10),
        second: parseInt(map.second, 10)
      };
    }

    function zoneOffset(date, timeZone) {
      var p = zonedParts(date, timeZone);
      return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - date.getTime();
    }

    function msUntilMidnight(timeZone, now) {
      if (!timeZone || timeZone === 'local') {
        var end = new Date(now.getTime());
        end.setHours(24, 0, 0, 0);
        return end.getTime() - now.getTime();
      }
      var p = zonedParts(now, timeZone);
      var nextWall = Date.UTC(p.year, p.month - 1, p.day + 1, 0, 0, 0);
      var instant = nextWall - zoneOffset(now, timeZone);
      var adjusted = zoneOffset(new Date(instant), timeZone);
      instant = nextWall - adjusted;
      var confirm = zoneOffset(new Date(instant), timeZone);
      if (confirm !== adjusted) instant = nextWall - confirm;
      return instant - now.getTime();
    }

    function render(bar, now) {
      var zone = bar.getAttribute('data-timezone') || 'local';
      var left = msUntilMidnight(zone, now);
      if (!(left >= 0)) left = 0;
      var total = Math.floor(left / 1000);
      var hours = Math.floor(total / 3600);
      var minutes = Math.floor((total % 3600) / 60);
      var seconds = total % 60;
      var h = bar.querySelector('[data-elura-unit="h"]');
      var m = bar.querySelector('[data-elura-unit="m"]');
      var s = bar.querySelector('[data-elura-unit="s"]');
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
    }

    function refresh() {
      var bars = document.querySelectorAll('[data-elura-announcement][data-timezone]');
      if (!bars.length) return;
      var now = new Date();
      var i;
      for (i = 0; i < bars.length; i++) render(bars[i], now);
    }

    function syncHeights(section) {
      if (section) {
        document.documentElement.style.setProperty('--elura-announcement-height', section.offsetHeight + 'px');
      }
    }

    function place(root) {
      if (!root) return;
      var section = root.closest('.shopify-section');
      var header = document.querySelector('.section-header');
      if (!section || !header) return;
      if (section.parentElement === header && header.parentElement) {
        header.parentElement.insertBefore(section, header);
      }
      var behavior = root.getAttribute('data-sticky') || 'with-header';
      var stickyHeader = header.querySelector('sticky-header');
      section.classList.remove('elura-announcement-with-header', 'elura-announcement-persist');
      if (behavior === 'with-header' && stickyHeader) {
        section.classList.add('elura-announcement-with-header');
      } else {
        section.classList.add('elura-announcement-persist');
      }
      syncHeights(section);
    }

    function placeAll() {
      var bars = document.querySelectorAll('[data-elura-announcement]');
      var i;
      for (i = 0; i < bars.length; i++) place(bars[i]);
    }

    placeAll();
    refresh();
    setInterval(refresh, 1000);
    window.addEventListener('resize', placeAll);
    window.addEventListener('load', placeAll);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-elura-announcement]');
      if (root) place(root);
      refresh();
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeAll);
    setTimeout(placeAll, 0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
